import { z } from "zod";

// D72 — Multi-Dokument-Host („Levels"). Generischer Mechanismus (Tier 2): das Framework
// verwaltet N Dokumente desselben aktiven Editor-Typs (öffnen/wechseln/neu/umbenennen/löschen)
// über die ProjectSource (D69); der Editor liefert NUR das Substantiv + Verzeichnis + Endung.
//
// Konsistent mit D66 („Menüs editor-spezifisch, Editor-Auswahl bleibt Shell"): der „Levels"-Tab
// ist der shared Switcher, VOM EDITOR beschriftet. Jedes Dokument ist ein eigenständiges TDoc
// (eigene Datei, z.B. `levels/level-01.level.json`).

/** Hinweis des EditorCore an den Multi-Dokument-Host (D72). */
export const DocumentSetHint = z.object({
  /** UI-Beschriftung des oberen Switcher-Tabs, z.B. "Level" | "Rig" | "Map". */
  noun: z.string().min(1),
  /** Verzeichnis relativ zum Projekt-Root (z.B. "levels"). */
  dir: z.string().min(1),
  /** Datei-Endung der Dokumente (inkl. Punkt, z.B. ".level.json"). */
  extension: z.string().min(1),
});
export type DocumentSetHint = z.infer<typeof DocumentSetHint>;
